module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/forward-8753de920f4f2383c39b528c0f7cd980.svg";